





export default {
  name: "packetblock",
  props: ['frameinfo', 'traceid', 'connid', 'packetid', 'timestamp', 'frameoffset'],
  data() {
      return {
          transamount: 10
      }
  },
  computed: {
    fillcolor(){
        return this.$store.state.framecolortables.getFrameColour([this.frameinfo.frametype]);
    },
    strokewidth(){
        if (this.$store.state.vissettings.getFile(this.traceid).getConn(this.connid).isPacketSelected(this.packetid))
            return 2;
        else
            return 0;
    },
    translateY(){
        return (this.frameoffset % 5)  * this.transamount;
    },
    xoffset(){
        return this.$store.state.vissettings.getFile(this.traceid).getConn(this.connid).getXOffset();
    }
  },
  methods: {
    selectpacket: function(){
        let data = {
            traceid: this.traceid, 
            connid: this.connid, 
            packetid: this.packetid
        };

        this.$store.dispatch('setSelectedPacket', data);
    },

    // called by TimeScaleState directly when it knows we need to update
    // using computed properties based on this.$store was too slow with this large an anmount of StreamBlocks
    updateXAfterZoom(xScaleFunction:any){
        let x = xScaleFunction( (this.timestamp * 1000) + parseInt(this.xoffset) );
        this.$el.transform.baseVal.getItem(0).setTranslate(x, this.translateY);
    }
  }
};
